import { keys } from "core-js/fn/array";
import {pathMain, pathNewsSubAll, pathDemandSubFree}  from "./config/vars";
import { empty } from "./functions";


export const actDefault: string = "default"
export const actPay: string = "pay"
export const actClaims: string = "claims"
export const actCharges: string = "charges"
export const actRegisters: string = "registers"
export const actNews: string = "news"
export const actAccount: string = "account"
export const actUrl: string = "url"

export const actUrl_keyExternalUrl: string = "external_url"
export const actClaims_keyClaimId: string = "claim_id"
export const actClaims_keyNewClaimGroup: string = "new_claim_group"
export const actClaims_keyNewClaimText: string = "new_claim_group"
export const actNews_keyNewsId: string = "news_id"
export const act_keyAccountId: string = "account_id"
export const act_keyRequestForAddPhone: string = "request_for_add_phone"

export const initActivities = () => {
    let ret = {}
    //@ts-ignore
    ret[actDefault] = {
        path: pathMain,
        keys: []
    }
    //@ts-ignore
    ret[actClaims] = {
        path: pathDemandSubFree,
        keys: [actClaims_keyClaimId, actClaims_keyNewClaimGroup, actClaims_keyNewClaimText]
    }
    //@ts-ignore
    ret[actNews] = {
        path: pathNewsSubAll,
        keys: [actNews_keyNewsId]
    }
    //@ts-ignore
    ret[actPay] = {
        path: pathMain,
        keys: []
    }
    //@ts-ignore
    ret[actCharges] = {
        path: pathMain,
        keys: []
    }
    //@ts-ignore
    ret[actRegisters] = {
        path: pathMain,
        keys: []
    }
    //@ts-ignore
    ret[actAccount] = {
        path: pathMain,
        keys: [act_keyAccountId, act_keyRequestForAddPhone]
    }
    //@ts-ignore
    ret[actUrl] = {
        path: pathMain,
        keys: [actUrl_keyExternalUrl]
    }
    return ret
}

export const activities = initActivities() 

export const createPathByActivities = (data: object) => {
    if(empty(data)) return ""
    console.log("came_2act:", data)
    let retPath: string = pathMain +"?"
    //@ts-ignore
    let act = data["activity"] as string
    //@ts-ignore
    if(empty(act) || empty(activities[act])) return retPath
    //@ts-ignore
    retPath = activities[act].path + "?"
    //@ts-ignore
    let actKeys = activities[act].keys as string[]
    let params: string[] = []
    actKeys.forEach(k => {
        //@ts-ignore
        if(k in data) params.push(encodeURIComponent(k) + "=" + encodeURIComponent(data[k]))
    })
    return retPath + params.join("&")
}
